import React from 'react';
import { ShoppingCart, ShieldCheck, Zap, CheckCircle2 } from 'lucide-react';
const includedItems = ['Los 6 Capítulos completos del sistema Handball Coach Pro', 'Clases listas según edad: infantiles, adolescentes y adultos', '+100 ejercicios visuales y planificación anual', 'Módulo de nutrición y prevención de lesiones'];
const bonusItems = ['50 Clases Express listas para usar', 'Sistema de rotación y armado de equipos', 'Planillas para profesores', 'Juegos y dinámicas grupales', 'Manual de emergencias del entrenador', 'Calendario anual del profesor', '⚡ Psicología Deportiva (base) — EXTRA por comprar hoy'];
export function BuySection() {
  const checkoutUrl = 'https://checkout.ebookpoint.shop/cart/59567232385105:1';
  return <section className="py-16 px-4 bg-white" id="comprar" data-id="element-33">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl border border-blue-100 overflow-hidden" data-id="element-34">
        <div className="bg-blue-900 p-6 text-center" data-id="element-35">
          <h2 className="text-2xl md:text-3xl font-oswald font-bold text-white uppercase" data-id="element-36">
            Acceso Inmediato al Sistema Completo
          </h2>
          <p className="text-blue-200 font-medium mt-1 text-sm" data-id="element-37">
            Esto es todo lo que te llevás hoy
          </p>
        </div>

        <div className="p-6 md:p-8" data-id="element-38">
          {/* Summary list — compacted */}
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 mb-6" data-id="element-39">
            <ul className="space-y-2 mb-4" data-id="element-40">
              {includedItems.map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700 text-sm md:text-base" data-id="element-41">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-42" />
                  <span data-id="element-43">{item}</span>
                </li>)}
            </ul>

            <div className="border-t border-blue-200 pt-3 mt-3" data-id="element-44">
              <p className="font-oswald font-bold text-blue-900 uppercase text-sm mb-2" data-id="element-45">
                🎁 + 6 Bonos Gratis
              </p>
              <ul className="space-y-1.5" data-id="element-46">
                {bonusItems.map((item, i) => <li key={i} className="flex items-center justify-between text-sm gap-3" data-id="element-47">
                    <span className="flex items-center gap-2 text-slate-700" data-id="element-48">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 flex-shrink-0" data-id="element-49" />
                      <span data-id="element-50">{item}</span>
                    </span>
                    <span className="font-bold text-blue-600 text-xs whitespace-nowrap" data-id="element-51">
                      GRATIS
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Pricing */}
          <div className="text-center mb-6" data-id="element-52">
            <span className="text-slate-400 line-through text-lg font-bold block mb-1" data-id="element-53">
              Precio Normal: $52.690
            </span>
            <p className="text-slate-700 font-medium mb-2" data-id="element-54">
              Hoy lo llevás por:
            </p>
            <div className="flex justify-center items-baseline gap-2" data-id="element-55">
              <span className="text-5xl md:text-6xl font-oswald font-bold text-blue-600" data-id="element-56">
                $19.899
              </span>
              <span className="text-xl text-slate-500 font-bold" data-id="element-57">ARS</span>
            </div>
            <p className="text-blue-600 font-bold mt-2 animate-pulse" data-id="element-58">
              ¡Oferta válida solo por hoy!
            </p>
          </div>

          <a href={checkoutUrl} className="flex items-center justify-center gap-3 w-full px-8 py-5 bg-blue-600 hover:bg-blue-700 text-white text-xl md:text-2xl font-oswald font-bold uppercase rounded-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-blue-500/40" data-id="element-59">
            <ShoppingCart className="w-6 h-6 md:w-8 md:h-8" data-id="element-60" />
            QUIERO MI ACCESO AHORA
          </a>

          <div className="mt-6 flex flex-col sm:flex-row justify-center items-center gap-6 text-slate-600 font-medium" data-id="element-61">
            <div className="flex items-center gap-2" data-id="element-62">
              <ShieldCheck className="w-5 h-5 text-blue-600" data-id="element-63" />
              <span data-id="element-64">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-65">
              <Zap className="w-5 h-5 text-blue-600" data-id="element-66" />
              <span data-id="element-67">Acceso Inmediato PDF</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}